<template>
	<section v-if="rows.length" class="embedded-genogram-legend-column">
		<h3 class="embedded-genogram-legend-column__title">{{ title }}</h3>
		<div class="embedded-genogram-legend-column__rows">
			<EmbeddedGenogramLegendRow
				v-for="(row, index) of rows"
				:key="`${title}-${index}`"
				:row-type="row.rowType"
				:text="row.text"
				:src="row.src"
				:symbol-type="row.symbolType"
				:sexual-communication="row.sexualCommunication"
				:color="row.color"
				:is-family-line="row.isFamilyLine"
				:is-primary-person="row.isPrimaryPerson"
				:is-passed-away="row.isPassedAway"
				:hover-item="row.hoverItem"
				:is-hoverable="isHoverable"
				:is-locked="row.isLocked"
				:is-hovered="row.isHovered"
				@hover-start="$emit('hover-start', $event)"
				@hover-end="$emit('hover-end')"
				@toggle-lock="$emit('toggle-lock', $event)"
			/>
		</div>
	</section>
</template>

<script>
import EmbeddedGenogramLegendRow from "./EmbeddedGenogramLegendRow.vue";

export default {
	name: "EmbeddedGenogramLegendColumn",
	components: {EmbeddedGenogramLegendRow},

	props: {
		title: {type: String, required: true},
		rows: {type: Array, default: () => []},
		isHoverable: Boolean,
	},
}
</script>

<style lang="scss">
.embedded-genogram-legend-column{
	flex: 0 1 150px;
	min-width: 150px;
	max-width: 100%;
	display: flex;
	flex-direction: column;
	gap: 8px;
}

.embedded-genogram-legend-column__title{
	margin: 0;
	font-size: 11px;
	font-weight: 700;
	line-height: 1.2;
	letter-spacing: 0.08em;
	text-transform: uppercase;
	color: #7b8794;
}

.embedded-genogram-legend-column__rows{
	display: flex;
	flex-direction: column;
	gap: 6px;
	min-width: 0;
}
</style>
